// eslint-disable-next-line no-restricted-syntax
export enum CbhFeatureFlag {
  MASS_SHIFT_UPLOAD = "mass-shift-upload",
  SHOULD_SHOW_WORKER_ETA = "should-show-worker-eta",
  // Note: This is a temporary key and will be remove once feature is release for all the users.
  BASE_RATE_PAY_FILTERS = "base-rate-pay-filters",
  BASE_RATE_MULTIPLE_PAY_FILTERS = "base-rate-multiple-pay-filters",
  NLC_STATES = "nlc-states",
  PERSONAL_ID_SUBTYPES = "personal-id-subtypes",
  HCP_MINIMUM_CHARGE_RATES = "hcp-minimum-charge-rates",
  WORKER_RATINGS_CAROUSEL = "worker-ratings-carousel",
  SUPPORT_LINKS = "support-links",
  CALIFORNIA_TIMESHEET = "california-timesheet",
  WORKER_SERVICE_FOR_ADMIN_PANEL = "use-worker-service-for-admin-panel",
  WORKER_SERVICE_MIGRATED_API_MAP = "worker-service-migrated-api-map-for-admin-panel",
  VARIABLE_CHARGE_STANDARD = "variable-charge-standard",
  RECOMMENDED_RATE_FOR_CHARGE_BLOCKED_FACILITIES = "recommended-rates-for-charge-blocked-facilities",
  RATE_NEGOTIATION_ACTIVATION = "rate-negotiation-activation",
  MY_ACCOUNT_PAGE = "myaccount-page",
  RATE_NEGOTIATION_LIMITS = "rate-negotiation-limits",
  RATE_NEGOTIATION_DISPLAY_WORKER_RATING = "rate-negotiation-display-worker-rating",
  MARKETING_CONVERSION_QUALIFICATIONS_WHITELIST = "marketing-conversion-qualifications-whitelist",
  BULK_UPDATE_EMPLOYEE_ROLES = "bulk-update-employee-roles",
  SENDBIRD_CONCURRENT_CONNECTION_OPTIMIZATION = "send-bird-concurrent-connection-optimisation",
  MAKE_RATING_FEEDBACK_REQUIRED = "make-rating-feedback-required",
  SHOULD_SHOW_LIVE_MAP_VIEW = "show-live-worker-eta-map",
  AUTO_EXPAND_SHIFTS_PANEL_IN_CALENDAR_PAGE = "auto-expand-shifts-panel-in-calendar-page",
  POST_SHIFT_OPTIONS_AB_TESTING = "post-shift-options-a-b-testing",
  HCF_ONBOARDING = "hcf-onboarding",
  WORKPLACE_BLOCK_SHIFTS_TYPE_FORMS = "workplace-assignment-typeforms",
  USP_CLIENT_SETTINGS = "usp-client-settings",
  IN_APP_CHAT_LIMITED_DAYS_AFTER_BOOKED_SHIFT = "in-app-chat-limited-days-after-last-booked-shift",
  SHOW_RATE_NEGOTIATION_CONTROL_TOGGLE = "show-rate-negotiation-control-toggle",
  ATTENDANCE_RATE_CONFIG = "attendance-rate-config",
  VARIABLE_CHARGE_REVAMPED_ACCESS_CONTROL = "variable-charge-revamped-access-control",
  WORKPLACE_SELF_SIGNUP = "workplace-self-signup",
  REMOVE_ADDED_MANUAL_PAY_WHEN_MANUAL_CHARGE = "remove-added-manual-pay-when-manual-charge",
  AVAILABLE_WORKERS_SHIFT_INFO_TEXT = "available-workers-shift-info-text",
  MAPLE_INTEGRATION = "maple-integration",
  UI_STRIPE_TRANSFERS = "ui-stripe-transfers",
  ADMIN_APP_HIDE_PAYROLL_TABLE = "admin-app-hide-payroll-table",
  WORKER_BLOCK_BOOKING = "worker-block-booking",
  SHOULD_SHOW_CONTRACT_TERMS = "should-show-contract-terms",
  FIREBASE_24_HOURS_EXPIRY_ENABLED = "2023-10-sparta-rollout-expire-firebase-token-in-24-hours",
  LD_UPGRADE_TESTING_WITH_CONTEXT = "2023-11-07-ld-upgrade-testing-with-context",
  EDIT_SHIFT_TIME_RESTRICTION = "2023-12-facilitate-edit-shift-time-restriction",
  AUTOMATIC_TIME_SLOT_UPDATE = "2025-04-enable-automatic-time-slot-update",
  VIEW_SHIFT_CHARGE_RATE = "2023-12-facilitate-view-shift-charge-rate",
  MAXIMUM_ALLOWED_WORKPLACE_CHARGE_RATES = "2024-01-facilitate-maximum-allowed-workplace-charge-rates",
  SHIFT_INVITE_CONFIGURATION = "2024-01-invaluables-configure-shift-invites",
  ROLLOUT_CHAT_CREATION = "2024-01-facilitate-rollout-chat-creation",
  ROLLOUT_BLOCK_BOOKING = "2024-02-facilitate-rollout-block-shift-booking",
  ROLLOUT_QUIZ_V2_FACILITY_RULES_AI = "2024-02-action-rollout-quiz-v2-facility-rules-ai",
  ROLLOUT_WORKPLACE_RULES_WITH_QUIZ = "2025-06-rollout-workplace-rules-and-quiz",
  SHOW_UPDATED_DNR_COPY = "2024-05-value-show-updated-dnr-copy",
  ENABLE_SHIFT_SPECIFICATION = "2024-06-facilitate-add-shift-specification",
  UNFILLED_PAST_SHIFT_DELETION = "2024-07-team-facilitate-rollout-unfilled-past-shift-deletion",
  WORKPLACE_REFERRALS = "2023-10-facilitate-rollout-workplace-referrals",
  HOME_HEALTH_ENABLED = "2024-01-home-health-HCF-HHA-enabled",
  HOME_HEALTH_PAY_RATES = "2024-03-home-health-default-pay-rates-per-visit-type",
  HOME_HEALTH_WORKER_CHAT_ENABLED = "2024-03-home-health-worker-chat-enabled",
  HOME_HEALTH_FOOTER_URLS = "2024-05-home-health-hcf-footer-urls",
  HOME_HEALTH_BONUS_PAYMENT = "2024-05-home-health-bonus-payment",
  NON_WORKER_CLOCK_IN = "2024-08-non-worker-clock-in",
  HOME_HEALTH_ONBOARDING_ENABLED = "2024-07-home-health-onboarding-enabled",
  SHOW_AVAILABLE_WORKERS_CONFIG = "notify-available-workers-about-shift-creation",
  HOME_HEALTH_PT_ENABLED = "2024-08-home-health-pt-enabled",
  HOME_HEALTH_OCCUPATIONAL_THERAPIST_ENABLED = "2026-03-enable-home-health-occupational-therapist",
  HOME_HEALTH_SOCIAL_WORKER_ENABLED = "2026-03-enable-home-health-social-worker",
  CALENDAR_POPOVER_ENABLED = "2024-09-team-facilitate-calendar-popover-enabled",
  SHIFT_INVITE_CUSTOM_RATE_BOOST = "2024-09-invaluables-rollout-custom-rate-boost",
  HOME_HEALTH_MENU_ITEMS_HIDDEN = "2024-09-home-health-menu-items-hidden",
  SHIFT_INVITE_POST_TO_MARKETPLACE_DEFAULT = "2024-09-invaluables-post-shift-to-marketplace-default",
  ADMIN_APP_GENERIC_OUTAGE_BANNER = "admin-app-generic-outage-banner",
  HIDE_BROWSER_WORKERS = "2024-09-facilitate-rollout-hide-browser-workers",
  RELOAD_PAGE_ON_USER_SWITCH = "2024-10-facilitate-reload-page-on-user-switch",
  OVERRIDE_FACILITY_REQUIRED_DOCS_FOR_SHIFT_INVITE = "2024-10-invaluables-override-facility-required-docs-for-shift-invite",
  SHOW_QUIZ_ATTEMPTS = "2024-team-action-show-quiz-attempt-pdf-document",
  FACLITY_QUIZ_LAYOUT_AB = "2024-10-action-facility-quiz-layout-AB",
  EARLY_CLOCK_IN_ENABLED_IN_MINUTES = "2024-10-facilitate-rollout-early-clock-in-enabled-in-minutes",
  RATING_QUALITIES_OPTIONS = "2024-11-facilitate-rollout-rating-qualities-options",
  PLACEMENTS_ACCESS_CONTROL_ROLLOUT = "2024-11-facilitate-rollout-placements-access-control",
  EXTEND_BOOKABILITY_MODAL_CONFIGURATION = "2024-11-invaluables-configure-extend-bookability-modal",
  ROLLOUT_PARENT_MANAGED_PLACEMENTS = "2024-11-facilitate-rollout-parent-managed-placements",
  APP_VERSION_UPDATE_CONTROL = "2024-12-facilitate-hcf-web-version-update-control",
  REBRAND_MAX_CONSECUTIVE_HOURS_TO_NO_DOUBLES = "2024-12-invaluables-rollout-rebrand-max-conescutive-hours-to-no-doubles",
  DNR_CONFIG = "2024-12-invaluables-config-dnr-reason",
  WORKER_INSTRUCTION_PANEL_VISIBILITY = "worker-instruction-panel-visibility",
  WORKER_LEFT_EARLY = "2025-03-alchemy-worker-left-early",
  ROLLOUT_JOB_INTERVIEWS = "2025-01-27-facilitate-rollout-job-interviews",
  EVENT_PROMOTION_ALERT = "2025-01-30-facilitate-event-promotion-alert",
  LATE_CANCELLATION_LEAD_TIME_THRESHOLD_IN_HOURS = "2024-11-value-configure-late-cancellation-lead-time-threshold-in-hours",
  BOOKED_SHIFT_TIME_PROPOSALS = "2025-03-invaluables-rollout-booked-shift-time-proposals",
  CANCELLATION_REASON_CONFIG = "2025-02-invaluables-config-cancellation-reason",
  VIEW_SHIFT_TABLE = "2025-04-hackathon-admin-shift-table",
  PRICING_HACKATHON = "2025-07-pricing-hackathon",
  DISPLAY_EDIT_NEEDS_BUTTON = "2025-07-hackathon-display-edit-needs-button",
  CBH_LITE_TRIAL_BANNER = "2025-04-offsiteexperiment-cbh-lite-trial-mode",
  CHHA_REGISTRY_CONFIG = "2025-03-growth-chha-registry-config",
  HH_ENABLE_UNSKILLED_QUALIFICATIONS = "2025-03-growth-enable-unskilled-qualifications",
  SHIFT_INVITE_FRICTION_CONFIG = "2025-05-shift-invites-friction-configuration",
  DONUT_DELIVERY_INCENTIVE_FOR_BLOCKING_WORKERS = "2025-05-donut-delivery-incentive-for-blocking-workers",
  FACILITY_BACKGROUND_CHECK_UPLOADS = "2025-05-forge-facility-background-check-uploads",
  BASKET_SIZE_LIMIT_CONFIGURATION = "2025-05-enable-basket-size-limit-configuration",
  ENABLE_CHARTING_RECALL = "2025-06-enable-charting-recall",
  ROLLOUT_EXCLUSION_CANDIDATES_BANNER = "2025-06-rollout-exclusion-candidates-banner",
  HIRING_QUALIFICATION_RANKING = "2025-07-rollout-hiring-qualification-ranking",
  ADMIN_SHIFT_TRACKER = "2025-07-admin-shift-tracker",
  MATRIX_WINDOWING_SEQUENCE = "2024-12-matrix-windowing-sequence",
  CALENDAR_BULK_SHIFT_POSTING = "2025-07-calendar-bulk-posting",
  WAIT_AND_SAVE = "2025-08-pricing-rollout-wait-and-save-pricing-rule",
  SIMPLIFIED_SHIFT_CANCELLATION_MODAL = "2025-07-orbit-simplified-shift-cancellation-modal",
  SCHEDULE_INTERVIEW_BY_WORKPLACE = "2025-07-facilitate-schedule-interview-by-workplace",
  FACILITY_DASHBOARD_BANNERS = "2025-07-facility-dashboard-configurable-banners",
  FACILITY_EXPLO_ANALYTICS_ENABLED = "2025-08-facility-explo-analytics-enabled",
  PLACEMENT_PERKS_CONFIGURATION = "2025-08-facility-type-placement-perks",
  WORKPLACE_TO_WORKER_REFERRALS = "2025-08-workplace-to-worker-referrals",
  CUSTOM_QUALIFICATIONS_ENABLED = "2025-06-custom-qualifications-enabled",
  HCP_LICENSE_DEFAULT_STATUS = "hcp-license-default-status",
  INDEPENDENT_CONTRACTOR_BADGE_REVAMP = "2025-08-independent-contractor-badge-revamp",
  CANDIDATES_AWAITING_REVIEW_BANNER_AND_BADGE = "2025-09-candidates-awaiting-review-banner-and-badge",
  ORIENTATION_SHIFTS_CONFIGURATION = "2025-09-configure-orientation-shifts",
  DEFAULT_PLACEMENT_APPLICATION_STATUS_VIEW = "2025-09-default-placement-application-status-view",
  AUTO_CLOSE_STALE_INTERVIEW_REQUESTS_VIEW = "2025-09-auto-close-stale-interview-requests-view",
  ENABLE_NEW_GRAD_FRIENDLY_SHIFTS = "2025-09-gaia-enable-new-grad-friendly-shifts",
  STARRED_PROFESSIONAL_CONFIGURATION = "2025-10-configure-starred-professionals",
  REQUIRE_WORKPLACE_AGREEMENT = "2025-10-enable-require-workplace-arbitration-agreement",
  WORKPLACE_REQUEST_NEW_WORKER_REQUIREMENT_RATE = "2025-10-workplace-request-new-worker-requirement-rate",
  ENABLE_HIRING_NON_INSTANT_BOOK_EASY_SCHEDULING = "2025-10-enable-hiring-non-instant-book-easy-scheduling",
  PLACEMENT_SCRAPING_CONFIG = "2026-03-configure-placement-scraping",
  PRN_WORKERS_INVITATION_ROLLOUT = "2025-11-prn-workers-rollout",
  ADMIN_APP_NAVIGATION_REDESIGN_ENABLED = "2025-10-admin-navigation-redesign-enabled",
  HACKATHON_CONFIGURE_INSTANT_FILL_SHIFTS = "2025-11-hackathon-configure-instant-fill-shifts",
  STAFF_LION_INTEGRATION_CONFIG = "2025-05-forge-staff-lion-integration-config",
  MISSED_PUNCH_REQUEST = "2025-11-missed-punch-request",
  TOUCHPOINT_INTEGRATION = "2025-01-team-x-touchpoint-integration",
  CREDENTIAL_REQUIREMENT_CONFIGURATION = "2025-12-configure-credential-requirements",
  CALENDAR_SEARCH_BY_SHIFT_ID = "2026-01-calendar-search-by-shift-id",
  CALENDAR_SEARCH_BY_WORKER_ID = "2026-01-rollout-calendar-search-by-worker-id",
  USERS_ALLOWED_TO_OVERRIDE_SHIFT_ASSIGNMENT_BLOCKERS = "2026-01-users-allowed-to-override-shift-assignment-blockers",
  CONFIGURE_SPENDING_CONTROLS = "2026-01-configure-spending-controls",
  ENABLE_JOB_CLOSURE_KEEPING_CANDIDATES = "2026-01-enable-job-closure-keeping-candidates",
  SHIFT_GENDER_REQUIREMENT_CONFIG = "2026-01-gender-specific-shifts-config",
  WINTER_STORM_BANNER = "2026-01-pricing-variable-charge-banner",
  CONFIGURE_VISIT_RATE_SETTING = "2026-01-configure-visit-rate-setting",
  LOCAL_SHIFT_TIME_OVERRIDE = "2026-01-release-local-shift-time-override",
  RESTRICT_OVERWORK_INVITES_TOGGLE = "2026-02-restrict-overwork-invites-toggle",
  WORKER_REQUESTED_CANCEL_ALERT = "2026-02-worker-requested-cancel-alert",
  CHARTING_CREDENTIAL_PROVISIONING_CONFIG = "2026-01-configure-credential-auto-provision",
  ENABLE_WORKPLACE_USER_COGNITO_MAGIC_LINKS = "2026-02-enable-workplace-user-cognito-magic-links",
  IS_ADMISSION_AND_FIRST_VISIT_ENABLED = "2026-02-experiment-admission-and-first-visit",
  SHIFT_INVITE_PRICE_API = "2026-02-release-shift-invite-price-api",
  POST_URGENT_SHIFT = "2026-02-enable-post-urgent-shift",
  ALCHEMY_SHIFT_BOARD_ROLLOUT = "2025-07-alchemy-shift-board-rollout",
  EDIT_MULTIPLE_SHIFTS_VARIABLE_CHARGE = "2026-02-rollout-edit-multiple-shifts-variable-charge",
  IN_HOME_LOCK_ENABLED = "2026-02-enable-in-home-lock",
  ADMIN_ENABLE_COGNITO_IN_API_CALLS = "2026-03-admin-enable-cognito-in-api-calls",
  ENABLE_ADMIN_APP_PASSWORD_COGNITO_AUTH = "2026-03-enable-admin-app-password-cognito-auth",
  DISABLE_FIREBASE_SESSION_FALLBACK = "2026-03-disable-firebase-session-fallback",
  PROBLEMATIC_REQUIREMENTS_BANNER = "2026-03-configure-problematic-requirements-banner",
  WORKPLACE_APP_REBRAND_ENABLED = "2026-03-release-workplace-app-rebrand",
  DOCS_V2_TOOLS_IN_ADMIN_UI = "2026-03-docs-v2-tools-in-admin-ui",
  DOCS_V2_UNIFIED_DOCUMENT_PATCH = "2026-05-docs-v2-unified-document-patch",
  ENABLE_MOBILE_CALENDAR_V2 = "2026-04-enable-mobile-calendar-v2",
  WORKPLACE_PUSH_NOTIFICATIONS_ENABLED = "2026-04-enable-workplace-push-notifications",
  SMS_PORTAL_ENABLED = "2026-04-gaia-enable-sms-portal",
  WORKPLACE_COGNITO_IMPERSONATION = "2026-04-release-workplace-cognito-impersonation",
  LAST_MINUTE_OPT_IN_VARIABLE_CHARGE_CONFIGURATION = "2026-04-configure-last-minute-opt-in-variable-charge-modal",
  FCF_UNBOOKED_SHIFT_SWAP = "2026-04-release-fcf-unbooked-shift-swap",
  WORKPLACE_VISIT_HEAT_MAP = "2026-04-enable-workplace-visit-heat-map",
  CLIPBOARD_ROSTER_ENABLED = "2026-04-experiment-clipboard-roster",
  BACKEND_CHARGE_RATE_VALIDATION = "2026-04-release-backend-charge-rate-validation",
  EXTEND_SHIFT_RELEASE = "2026-04-extend-shift-release",
  ENABLE_SHIFT_TRACKER = "2026-05-enable-shift-tracker",
  LIGHT_DARK_MODE_TOGGLE = "2026-05-release-admin-light-dark-mode-toggle",
  HIRING_MANAGER_ONBOARDING_WELCOME = "2026-05-release-hiring-manager-onboarding-welcome",
  SHOW_RUSH_FEE_SCHEDULE_IN_WORKPLACE_DRAWER = "2026-05-experiment-show-rush-fee-schedule-in-workplace-drawer",
  CHECK_TIERED_RUSH_FEE_SCHEDULE_IN_CONFIRMATION_DIALOG = "2026-05-release-check-tiered-rush-fee-schedule-in-confirmation-dialog",
  ENABLE_HHH_HCP_PROFILE_V2 = "2026-04-enable-hhh-hcp-profile-v2",
  WORKPLACE_RATING_PROMPT = "2026-05-enable-workplace-rating-prompt",
  HOME_HEALTH_WORKPLACE_MOBILE_EXPERIENCE_ENABLED = "2026-05-enable-home-health-workplace-mobile-experience",
  VARIABLE_CHARGE_BANNER_MEMORIAL_DAY = "2026-05-configure-variable-charge-banner-memorial-day",
  ROSTER_OVERTIME_CONFIG = "2026-05-config-roster-overtime",
}
